import toast from 'react-hot-toast';
import { AccessingView } from '../../common/accessingView';
import { LcarsFrame } from '../../components/lcarsFrame';
import { PageIdentity } from '../../pages/pageIdentity';
import { isTableCollectionAlreadyImported } from '../../state/tableFunctions';
import { TableMarshaller } from '../model/tableMarshaller';
import { useNavigate } from 'react-router';
import { store } from '../../state/store';
import {
  importTableCollection,
  setTableCollectionSelection,
} from '../../state/tableActions';

export const ImportTablePage = () => {
  const navigate = useNavigate();

  const url = new URL(window.location.href);
  const query = new URLSearchParams(url.search);
  const encodedTable = query.get('table');

  const collection = TableMarshaller.instance.unmarshall(encodedTable);

  if (isTableCollectionAlreadyImported(collection.uuid, encodedTable)) {
    setTimeout(() => {
      navigate('/tools/table');
      toast('This table has already been imported', {
        className: 'bg-warning',
      });
    }, 500);
  } else {
    setTimeout(() => {
      store.dispatch(importTableCollection(collection));
      store.dispatch(setTableCollectionSelection(collection));
      navigate('/tools/table/view');
      toast('Table successfully imported.', { className: 'bg-success' });
    }, 500);
  }

  return (
    <LcarsFrame activePage={PageIdentity.ImportTable}>
      <div id="app">
        <div className="ms-0 page container">
          <AccessingView />
        </div>
      </div>
    </LcarsFrame>
  );
};
